import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router/index.js'
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
	Loading
} from 'element-ui';

console.log(CryptoJS);

Vue.use(ElementUI)
axios.defaults.withCredentials = true
Vue.prototype.host = "https://ksmeilv.com/zuche"
// Vue.prototype.host = "http://10.10.0.2:8080";
Vue.prototype.timeFormat = function(dateTime = null, fmt = 'yyyy-mm-dd hh:MM:ss') {
	// 如果为null,则格式化当前时间
	if (!dateTime) {
		dateTime = Number(new Date());
		return;
	}
	// 如果dateTime长度为10或者13，则为秒和毫秒的时间戳，如果超过13位，则为其他的时间格式
	if (dateTime.toString().length == 10) dateTime *= 1000;
	let date = new Date(dateTime);
	let ret;
	let opt = {
		"y+": date.getFullYear().toString(), // 年
		"m+": (date.getMonth() + 1).toString(), // 月
		"d+": date.getDate().toString(), // 日
		"h+": date.getHours().toString(), // 时
		"M+": date.getMinutes().toString(), // 分
		"s+": date.getSeconds().toString() // 秒
		// 有其他格式化字符需求可以继续添加，必须转化成字符串
	};
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
		};
	};
	return fmt;
}

var CryptoKey = "aaaabbbbccccdddd";


function encrypt(word, keyStr) {
	keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
	var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
	var srcs = CryptoJS.enc.Utf8.parse(word);
	var encrypted = CryptoJS.AES.encrypt(srcs, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return encrypted.toString();
};
//解密
function decrypt(word, keyStr) {
	keyStr = keyStr ? keyStr : 'abcdefgabcdefg12';
	var key = CryptoJS.enc.Utf8.parse(keyStr); //Latin1 w8m31+Yy/Nw6thPsMpO5fg==
	var decrypt = CryptoJS.AES.decrypt(word, key, {
		mode: CryptoJS.mode.ECB,
		padding: CryptoJS.pad.Pkcs7
	});
	return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

var loading = null;
// 请求回来之后
Vue.use(ElementUI)
axios.interceptors.request.use(function(request) {
	var text = JSON.stringify(request.data);
	var jiami = encrypt(text, CryptoKey);
	request.data = "";
	request.data = {
		enCode: jiami
	};
	loading = Loading.service({
		text: '请稍等...'
	});
	return request;
}, function(error) {
	loading.close();
	return Promise.reject(error);
})
axios.interceptors.response.use(function(res) {
	var jiemi=decrypt(res.data.result,CryptoKey);
	jiemi=JSON.parse(jiemi);
	res.data.result=jiemi;
	loading.close();
	return res;
}, function(error) {
	console.log(error);
	loading.close();
	if (error.response.status === 401) {
		//没有登录
		router.push("/login");
	} else if (error.response.status === 403) {
		//没有权限
		console.log(ElementUI);
		ElementUI.MessageBox.alert('对不起，您没有权限，若需操作请联系管理员', '没有权限', {
			confirmButtonText: '知道了',
			callback: action => {
				// router.go(-1);
			}
		});

	} else if (error.response.status === 504) {
		router.push("/error_504");
	} else {
		ElementUI.Notification({
			type: 'error',
			title: '请求出现异常',
			message: '响应状态码：' + error.response.status
		})
	}
})

Vue.prototype.$axios = axios
new Vue({
	router,
	el: '#app',
	render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js